import Component from './Component';

export default class GlobalMessageComponent extends Component {
    get SELECTORS() {
        return {
            main: '.js-close-message',
            container: '.global-alerts',
            globalMessagesTemplate: 'globalMessages--template',
            globalMessagesDom: '.js-globalmessages'
        }
    }

    constructor() {
        super();
        this.countdown = null;
    }

    deleteMessages(selector, timer) {
        clearTimeout(this.countdown);
        this.countdown = setTimeout(() => {
            document.querySelectorAll(selector).forEach((el)=>{
                el.innerText = '';
            });
        }, timer);
    }

    renderGlobalMessages(text, status, speaker = false, isDeleted = true){
        // status warning/danger/info
        const response = {
            content: text,
            status: status,
            speaker: speaker
        }

        this.renderMustache(this.SELECTORS.globalMessagesTemplate, document.querySelector(this.SELECTORS.globalMessagesDom), response);
        if(isDeleted) {
            this.deleteMessages(this.SELECTORS.globalMessagesDom, 5000);
        }
    }

    bindEvents() {
        this.events.on('click', this.SELECTORS.main, (e) => {
            e.target.closest(this.SELECTORS.container).innerText = '';
        });

        if (document.querySelector(this.SELECTORS.globalMessagesDom).innerText != '') {
            this.deleteMessages(this.SELECTORS.globalMessagesDom, 5000);
        }
    }

    render() {
        this.log('render Global Message');
        this.bindEvents();
    }
}
